import styled from '@emotion/styled';
import CalendarTodayOutlined from '@mui/icons-material/CalendarTodayOutlined';
import DescriptionOutlined from '@mui/icons-material/DescriptionOutlined';
import PrintOutlined from '@mui/icons-material/PrintOutlined';
import SearchOutlined from '@mui/icons-material/SearchOutlined';
import SmartToyOutlined from '@mui/icons-material/SmartToyOutlined';
import { Box, Typography } from '@mui/material';
import {
  colorAgentBorder,
  colorAgentTextSecondary,
  colorNeutralGray,
  colorPrimaryDeepBlue,
} from '../styles/tokens';

const Container = styled(Box)`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 12px;
  overflow-y: auto;
`;

const HeaderRow = styled(Box)`
  display: flex;
  align-items: center;
  gap: 6px;
  padding-bottom: 8px;
  border-bottom: 1px solid ${colorAgentBorder};
  margin-bottom: 8px;
`;

const HeaderIcon = styled(SmartToyOutlined)`
  font-size: 16px;
  color: ${colorPrimaryDeepBlue};
`;

const HeaderTitle = styled(Typography)`
  font-size: 12px;
  font-weight: 600;
  color: ${colorPrimaryDeepBlue};
`;

const SuggestionList = styled(Box)`
  display: flex;
  flex-direction: column;
`;

const SuggestionItem = styled(Box)`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 8px;
  cursor: pointer;
  border-bottom: 1px solid ${colorNeutralGray};

  &:hover {
    background-color: ${colorNeutralGray};
  }

  &:last-child {
    border-bottom: none;
  }
`;

const SuggestionIcon = styled.span`
  display: flex;
  font-size: 14px;
  color: ${colorAgentTextSecondary};
`;

const SuggestionContent = styled(Box)`
  min-width: 0;
`;

const SuggestionTitle = styled(Typography)`
  font-size: 12px;
  font-weight: 600;
  line-height: 1.4;
`;

const SuggestionDescription = styled(Typography)`
  font-size: 11px;
  color: ${colorAgentTextSecondary};
  line-height: 1.3;
`;

interface PromptSuggestion {
  icon: typeof DescriptionOutlined;
  title: string;
  description: string;
  prompt: string;
}

const SUGGESTIONS: PromptSuggestion[] = [
  {
    icon: DescriptionOutlined,
    title: '契約情報を確認',
    description: 'リース契約の検索や詳細情報を確認できます',
    prompt: '現在の契約情報を確認して',
  },
  {
    icon: PrintOutlined,
    title: '帳票を出力',
    description: 'リース債務台帳や支払確認表を出力します',
    prompt: 'リース債務台帳を出力して',
  },
  {
    icon: SearchOutlined,
    title: '固定資産を検索',
    description: '資産台帳の検索ができます',
    prompt: '固定資産を検索して',
  },
  {
    icon: CalendarTodayOutlined,
    title: '処理月度を確認',
    description: '当期の処理月度や繰越状態を確認します',
    prompt: '現在の処理月度と繰越状態を教えて',
  },
];

interface WelcomeViewProps {
  onSuggestionClick: (prompt: string) => void;
}

export function WelcomeView({ onSuggestionClick }: WelcomeViewProps) {
  return (
    <Container>
      <HeaderRow>
        <HeaderIcon />
        <HeaderTitle>何かお手伝いできますか？</HeaderTitle>
      </HeaderRow>

      <SuggestionList>
        {SUGGESTIONS.map((s) => (
          <SuggestionItem key={s.prompt} onClick={() => onSuggestionClick(s.prompt)}>
            <SuggestionIcon as={s.icon} />
            <SuggestionContent>
              <SuggestionTitle>{s.title}</SuggestionTitle>
              <SuggestionDescription>{s.description}</SuggestionDescription>
            </SuggestionContent>
          </SuggestionItem>
        ))}
      </SuggestionList>
    </Container>
  );
}
